module.exports = __webpack_public_path__ + "img/store_video@1x@2x.03ff1e6.webp";